import { clearClientCredentials } from '../app/shared/utils/cookie.utils';
import { clearAccountDomain } from '../app/shared/utils/accountDomain.utils';

export const resetLocalStorage = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('userId');
  localStorage.removeItem('userDetails');
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('organizationId');
  localStorage.removeItem('role');
  localStorage.removeItem('features');
  localStorage.removeItem('projectId');
  localStorage.removeItem('SELECTED_ENV');
  clearAccountDomain();

  // Clear client credentials from cookies
  clearClientCredentials();
};
